import React from "react";

// Components
import BodyWrap from "./utils/BodyWrap";

// CSS
import "../css/not-found-page.css";

export default class NotFound extends React.PureComponent {
	render() {
		return (
			<BodyWrap>
				<main className="page-content not-found-page">
					<h1>404</h1>
					<div>Oops, the page you're looking for doesn't exist.</div>
				</main>
			</BodyWrap>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js